import { type EthereumProviderOptions } from '@walletconnect/ethereum-provider';
import { Web3ProviderConnector } from './Web3ProviderConnector';

export class WalletConnectConnector extends Web3ProviderConnector {
  constructor(name: string, opt: EthereumProviderOptions) {
    // @ts-ignore wallet connect的实例是兼容eip1193的，只是对象不一样而已
    super(name, async () => {
      const EthereumProvider = (await import('@walletconnect/ethereum-provider')).default;
      return EthereumProvider.init(opt);
    });
  }

  override async connect(recovery = false): Promise<string | undefined> {
    const provider = (await this.getProvider()) as any;
    if (!provider) {
      throw new Error('provider not found');
    }
    if (recovery) {
      await provider.enable();
    } else {
      await provider.connect();
    }
    return super.connect(recovery);
  }
}
